module.exports = __webpack_public_path__ + "367df69c8763a407b2bd1288a7d15791.png";